import { BigNumber } from "ethers";

export const BASE_MARGIN_AMOUNT = BigNumber.from('100000000')
